import { trans } from 'Rentlio/helper/translation'

export function cardCvvNumberConstraint(cardCvvNumber) {
  const cvvPattern = /^[0-9]{3,4}$/
  return cvvPattern.test(cardCvvNumber) ? null : trans('CVV invalid format')
}
